export const APP_VERSION = "v1.2.3"

// BASE_URL de la API dbsapify — se inyecta en build con VUE_APP_BASE_URL (ver docker/Dockerfile-oc).
//   prod    : sin var         -> https://dbsapify.theframework.es (fallback)
//   develop : compose-develop -> https://develop.dbsapify.79.72.52.214.sslip.io
//   local   : VUE_APP_BASE_URL=http://localhost:3000
export const BASE_URL = process.env.VUE_APP_BASE_URL || "https://dbsapify.theframework.es"
export const CONTEXT = "c3"
export const DB_NAME = "db-security"